import { boot } from "quasar/wrappers";
import { api } from "./api";

const INTERCOM_APP_ID = "wyz3ftpl";

/**
 * Identify logged-in user to Intercom with full profile data.
 * Call after login or on boot when user session is already active.
 */
export async function identifyIntercomUser(store) {
  if (!store.state.auth.is_user_logged_in || !store.state.auth.user?.login) {
    return;
  }

  const user = store.state.auth.user;
  let userHash = null;
  let companyAttributes = null;
  try {
    const response = await api.get('/api/v1/current-user/intercom');
    if (response.status === 200) {
      userHash = response.data.user_hash;
      companyAttributes = response.data.company;
    }
  } catch (err) {
    console.error('Error fetching Intercom profile:', err);
  }

  const settings = {
    app_id: INTERCOM_APP_ID,
    api_base: "https://api-iam.intercom.io",
    user_id: user.login,
    email: user.email,
    name: [user.first_name, user.last_name].filter(Boolean).join(" ") || undefined,
    user_hash: userHash,
  };

  if (user.company?.id) {
    settings.company = {
      company_id: String(user.company.id),
      name: user.company.name,
      ...(companyAttributes || {}),
    };
  }

  window.intercomSettings = settings;

  if (typeof window.Intercom === "function") {
    window.Intercom("boot", settings);
  }
}

/**
 * End Intercom session and relaunch as anonymous visitor.
 * Call on logout to clear user identity while keeping the chat bubble visible.
 */
export function shutdownIntercom() {
  if (typeof window.Intercom === "function") {
    window.Intercom("shutdown");
    // Reboot as anonymous so the chat bubble stays visible on the login page
    const anonymousSettings = {
      app_id: INTERCOM_APP_ID,
      api_base: "https://api-iam.intercom.io",
    };
    window.intercomSettings = anonymousSettings;
    window.Intercom("boot", anonymousSettings);
  }
}

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async ({ store }) => {
  /*===== Init BugPilot. =====*/
  // let scriptElement = document.createElement("script");
  // scriptElement.type = "text/javascript";
  // scriptElement.async = true;
  // scriptElement.src =
  //   "https://script.bugpilot.io/0ac56dfa-0068-48a4-ab56-3d6df05a8397/adopto.js";
  // document.querySelector("head").appendChild(scriptElement);
  // scriptElement.onload = function () {
  //   if (
  //     typeof window.Bugpilot !== "undefined" &&
  //     store.state.auth.is_user_logged_in
  //   ) {
  //     window.Bugpilot.identify({
  //       id: store.state.auth.user?.login, // Required
  //       email: store.state.auth.user?.email, // Required for help desk integrations
  //     });
  //   }
  // };

  /*===== Init Intercom. =====*/
  // Set base settings (even for anonymous visitors so widget loads)
  window.intercomSettings = {
    app_id: INTERCOM_APP_ID,
    api_base: "https://api-iam.intercom.io",
  };

  // If user is already logged in (returning session), identify them immediately
  await identifyIntercomUser(store);

  // Load Intercom widget script
  // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/wyz3ftpl'
  var w = window;
  var ic = w.Intercom;
  if (typeof ic === "function") {
    ic("reattach_activator");
    ic("update", w.intercomSettings);
  } else {
    var d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    var l = function () {
      var s = d.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://widget.intercom.io/widget/" + INTERCOM_APP_ID;
      var x = d.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    };
    if (document.readyState === "complete") {
      l();
    } else if (w.attachEvent) {
      w.attachEvent("onload", l);
    } else {
      w.addEventListener("load", l, false);
    }
  }

  /*===== Init UserGuiding. =====*/
  (function (g, u, i, d, e, s) {
    g[e] = g[e] || [];
    var f = u.getElementsByTagName(i)[0];
    var k = u.createElement(i);
    k.async = true;
    k.src =
      "https://static.userguiding.com/media/user-guiding-" + s + "-embedded.js";
    f.parentNode.insertBefore(k, f);
    if (g[d]) return;
    var ug = (g[d] = { q: [] });
    ug.c = function (n) {
      return function () {
        ug.q.push([n, arguments]);
      };
    };
    var m = [
      "previewGuide",
      "finishPreview",
      "track",
      "identify",
      "triggerNps",
      "hideChecklist",
      "launchChecklist",
    ];
    for (var j = 0; j < m.length; j += 1) {
      ug[m[j]] = ug.c(m[j]);
    }
  })(
    window,
    document,
    "script",
    "userGuiding",
    "userGuidingLayer",
    "785760344ID"
  );

  /*===== Init HotJar. =====*/
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 3257741, hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
});
